<template>
    <div class="display-con">
        <div class="flex-con sm-pad-lr is-start is-grow">
            <div v-if="conditionName" class="is-narrow">
                <div class="condition-name">{{conditionName}}</div>
            </div>
            <div>
                <condition
                    :unique-id="uniqueId"
                    :condition="condition"
                    :emit-label="true"
                    :available-fields="availableFields"
                    v-on:updated="updateCondition($event)"
                    v-on:enter="add"
                    ref="condition"
                    class="condition"
                ></condition>
            </div>
            <div class="is-narrow">
                <button
                    class="button is-primary"
                    @click="add"
                    :disabled="!valid"
                >
                    Add
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import '../filters/components/Condition';
import Condition from "../filters/components/Condition";

export default {
    name : "DynamicFilter",
    components : {Condition},
    props : {
        availableFields : {
            type : Object,
            required : true,
        },
        conditionName : String,
    },
    data () {
        return {
            uniqueId : 'dynamic',
            condition : {},
            valid : false,
        };
    },
    methods : {
        updateCondition (condition) {
            return new Promise(resolve => {
                this.condition = condition;

                if(this.$refs.condition && this.$refs.condition.customTypeConditionComponent) {
                    this.$validator.validateAll().then(valid => {
                        this.valid = valid;
                        resolve();
                    });
                    return;
                }

                if(this.$refs.condition && !this.$refs.condition.valueComponent) {
                    this.valid = true;
                    resolve();
                    return;
                }

                if(!this.$refs.condition || !this.$refs.condition.isValid){
                    this.valid = false;
                    resolve();
                    return;
                }
                if(this.$refs.condition.valueComponent) {
                    this.$validator.validateAll().then(valid => {
                        this.valid = valid;
                        resolve();
                    });
                } else {
                    this.valid = true;
                    resolve();
                }
            })
        },
        close () {
            this.condition = {};
            this.label = null;
            this.$emit('close');
        },
        add () {
            //force the valid flag again
            this.updateCondition(this.condition).then(() => {
                if(!this.valid){
                    return;
                }
                this.$emit('add', { condition : this.condition, label : this.$refs.condition.getLabel() });
                this.close();
            });
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/_theme';
    .display-con {
        position:absolute;
        background-color:$white-ter;
        border:1px solid $grey-lighter;
        z-index:10;
        padding:10px 20px;
        border-radius:8px;
        margin-top:10px;
        min-width:420px;
        max-width:100%;
        margin-left:-6px;

        .condition-name {
            margin-top:4px;
            text-transform: uppercase;
            font-size:14px;
        }

        &:before {
            content:"\A";
            border-style: solid;
            border-width: 0 10px 10px 10px;
            border-color: transparent transparent $grey-lighter transparent;
            position: absolute;
            left: 7px;
            top:-11px;
        }

    }
    .condition {
        margin:0 !important;
    }
</style>
